/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import { customFetch } from '../../mutator/custom-fetch';

export type detectLocaleResponse200 = {
  data: void
  status: 200
}

export type detectLocaleResponseSuccess = (detectLocaleResponse200) & {
  headers: Headers;
};
;

export type detectLocaleResponse = (detectLocaleResponseSuccess)

export const getDetectLocaleUrl = () => {


  

  return `/locale/detect`
}

export const detectLocale = async ( options?: RequestInit): Promise<detectLocaleResponse> => {
  
  return customFetch<detectLocaleResponse>(getDetectLocaleUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

